import { Card } from 'react-bootstrap'

function ChatMessage({ message }) {
  const isUser = message.role === 'user'
  const isAssistant = message.role === 'assistant'

  return (
    <div className={`d-flex mb-3 ${isUser ? 'justify-content-end' : 'justify-content-start'}`}>
      <Card
        className={`chat-message ${isUser ? 'bg-primary text-white' : 'bg-light'}`}
        style={{ maxWidth: '75%' }}
      >
        <Card.Body className="py-2 px-3">
          <small className="text-muted d-block mb-1">
            {isUser ? 'Vous' : isAssistant ? 'Assistant' : message.role}
          </small>

          {/* Text content */}
          {message.content && (
            <div style={{ whiteSpace: 'pre-wrap' }}>{message.content}</div>
          )}

          {/* Image content (for multimodal messages) */}
          {message.image && (
            <div className="mt-2">
              <img
                src={message.image}
                alt="Uploaded content"
                className="img-fluid rounded"
                style={{ maxHeight: '300px' }}
              />
            </div>
          )}

          {/* Generated image/video response */}
          {message.generatedImage && (
            <div className="mt-2">
              <img
                src={message.generatedImage}
                alt="Generated image"
                className="img-fluid rounded"
                style={{ maxHeight: '400px' }}
              />
            </div>
          )}

          {message.generatedVideo && (
            <div className="mt-2">
              <video
                src={message.generatedVideo}
                controls
                className="w-100 rounded"
                style={{ maxHeight: '400px' }}
              />
            </div>
          )}

          {/* Timestamp */}
          {message.timestamp && (
            <small className={`d-block mt-1 ${isUser ? 'text-white-50' : 'text-muted'}`}>
              {new Date(message.timestamp).toLocaleTimeString('fr-FR')}
            </small>
          )}
        </Card.Body>
      </Card>
    </div>
  )
}

export default ChatMessage
